import React from 'react';
import PageTemplate from '../PageTemplate';

const Activities = () => {
  return (
    <PageTemplate
      title="주요 활동"
      description="청소년 스마트폰 프리 운동본부의 주요 활동을 소개합니다"
    >
      <div style={{ padding: '2rem' }}>
        {/* 강연 섹션 */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.8rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            01 강연
          </h2>
          <div style={{ color: '#444', lineHeight: '1.8' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              청소년 스마트폰 프리 운동본부는 학교, 기관, 단체를 대상으로 스마트폰 과의존 예방과 
              올바른 디지털 미디어 사용에 대한 강연을 진행하고 있습니다.
            </p>
            
            <div style={{ 
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '8px',
              marginBottom: '2rem'
            }}>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>주요 강연 주제</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>스마트폰 과의존이 청소년 발달에 미치는 영향</li>
                <li>디지털 웰빙과 균형 잡힌 생활</li>
                <li>부모와 자녀가 함께하는 스마트폰 사용 규칙</li>
                <li>창의적인 비디지털 활동 방법</li>
                <li>디지털 시민성과 미디어 리터러시</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 캠페인 섹션 */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.8rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            02 캠페인
          </h2>
          <div style={{ color: '#444', lineHeight: '1.8' }}>
            <div style={{ 
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '8px',
              marginBottom: '2rem'
            }}>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>주요 캠페인</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>스마트폰 프리 챌린지</li>
                <li>디지털 디톡스 캠프</li>
                <li>가족과 함께하는 스마트폰 프리 데이</li>
                <li>학교 스마트폰 프리 존 만들기</li>
                <li>청소년 디지털 웰빙 서약</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 연구조사 섹션 */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.8rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            03 연구조사
          </h2>
          <div style={{ color: '#444', lineHeight: '1.8' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              청소년의 스마트폰 사용 실태와 영향에 대한 체계적인 연구조사를 수행하고 있습니다.
            </p>
            
            <div style={{ 
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '8px',
              marginBottom: '2rem'
            }}>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>주요 연구 분야</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>청소년 스마트폰 사용 실태 조사</li>
                <li>스마트폰 과의존이 학습능력에 미치는 영향</li>
                <li>디지털 기기가 청소년 발달에 미치는 영향</li>
                <li>스마트폰 프리 활동의 효과성 연구</li>
                <li>해외 정책 및 프로그램 사례 연구</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 입법 섹션 */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.8rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            04 입법
          </h2>
          <div style={{ color: '#444', lineHeight: '1.8' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              청소년의 건강한 디지털 생활을 위한 제도적 기반 마련을 위해 입법 활동을 진행하고 있습니다.
            </p>
            
            <div style={{ 
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '8px',
              marginBottom: '2rem'
            }}>
              <h3 style={{ color: '#2c3e50', marginBottom: '1rem' }}>주요 입법 활동</h3>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>청소년 디지털 기기 보호법 제정 추진</li>
                <li>학교 내 스마트폰 사용 규제 법안 발의</li>
                <li>디지털 웰빙 교육 의무화 법안 제안</li>
                <li>청소년 보호법 개정안 제안</li>
                <li>스마트폰 과의존 예방 조례 제정 지원</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 문의 섹션 */}
        <section>
          <h2 style={{ 
            color: '#e74c3c', 
            fontSize: '1.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e74c3c',
            paddingBottom: '0.5rem'
          }}>
            활동 문의
          </h2>
          <div style={{
            background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
            color: 'white',
            padding: '2rem',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <p style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>
              모든 활동 관련 문의는 아래 이메일로 연락주시기 바랍니다.
            </p>
            <p style={{ 
              fontSize: '1.3rem', 
              fontWeight: 'bold'
            }}>
              📧 phonfreekr@gmail.com
            </p>
          </div>
        </section>
      </div>
    </PageTemplate>
  );
};

export default Activities; 